import useNetworkCdnUserList from 'modules/queries/network/cdn/user/useList';
import useNetworkCdnZoneList from 'modules/queries/network/cdn/zone/useList';

const useInitCloudflare = () => {
	const { data: cdnUserData, isLoading: cdnUsersIsLoading } =
		useNetworkCdnUserList({});
	const cdnUser = cdnUserData?.items[0];

	const cdnZonesIsEnabled = Boolean(cdnUser);
	const { data: cdnZonesData, isLoading: cdnZonesIsLoadingRaw } =
		useNetworkCdnZoneList(
			{
				page_num: 1,
				page_size: 9999,
				cdn_user_id: Number(cdnUser?.id),
				alsowith: ['service_details'],
			},
			{ enabled: cdnZonesIsEnabled },
		);
	const zones = cdnZonesData?.items || [];

	const cdnZonesIsLoading = cdnZonesIsLoadingRaw && cdnZonesIsEnabled;
	const isLoading = cdnUsersIsLoading || cdnZonesIsLoading;

	return { cdnUser, zones, isLoading };
};

export default useInitCloudflare;
